import BankCardTypePrompt from './BankCardTypePrompt'

export default BankCardTypePrompt
